import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AuthInterceptor } from './auth.interceptor';
import { LangInterceptor } from './lang.interceptor';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ModalInteractionArchivesDetailsComponent } from './components/modal-interaction-archives-details/modal-interaction-archives-details.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalTutorialComponent } from './components/modal-tutorial/modal-tutorial.component';


import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';

import { CanDeactivateGuard } from './guards/can-deactivate.guard';

export function HttpLoaderFactory() {
  return new TranslateHttpLoader();
}

@NgModule({ declarations: [
        AppComponent,
        SidebarComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        CommonModule,
        NgxJsonViewerModule,
        FontAwesomeModule,
        ModalInteractionArchivesDetailsComponent,
        ModalTutorialComponent,
        NgSelectModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
            }
        })], providers: [
        { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: './assets/i18n/', suffix: '.json' } },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LangInterceptor, multi: true },
        CanDeactivateGuard,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}